const options = {
    add: false,
    blockPanel: true,
    visible: 3
};
export default options;
